export default "__VITE_ASSET__BvSkf$yq__"